import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PESilverCoatedEnvelopePaper = () => (
  <ProductDetailPage {...getProductPageConfig('peSilverCoatedEnvelopePaper')} />
);

export default PESilverCoatedEnvelopePaper;
